/**
 * @module M/plugin/XYLocator
 */
import 'assets/css/xylocator';
import { getValue } from './i18n/language';
import XYLocatorControl from './xylocatorcontrol';

export default class XYLocator extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor() {
    super();

    [this.facadeMap_, this.control_, this.panel_] = [null, null, null];
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api stable
   */
  addTo(map) {
    this.facadeMap_ = map;
    this.control_ = new XYLocatorControl();
    this.panel_ = new M.ui.Panel('M.plugin.XYLocator.NAME', {
      collapsible: true,
      className: 'm-xylocator',
      collapsedButtonClass: 'g-cartografia-posicion3',
      position: M.ui.position.TL,
      tooltip: getValue('tooltip'),
    });
    this.panel_.addControls(this.control_);
    map.addPanels(this.panel_);
  }

  /**
   * This function destroys this plugin
   *
   * @public
   * @function
   * @api stable
   */
  destroy() {
    this.facadeMap_.removeControls([this.control_]);
    [this.facadeMap_, this.control_, this.panel_] = [null, null, null];
  }
}

/**
 * Name to identify the plugin
 * @const
 * @type {string}
 * @public
 * @api stable
 */
XYLocator.NAME = 'XYLocator';
